import { ExistsJSONRouteAsync, GetJSONRouteAsync } from "../../FileAccess";
import { GenerateWeeklyActivity } from "../Map/GenerateWeeklyActivity";
import { GetDateSequence } from "../Utility/DateUtilities";

const _fFactors: number[] = [-0.03229737, 0.107107156, -0.400690144, -0.027112207, -0.460593227, 0.270438666, 0.073739909, -0.426932746, 0.959866969, -0.114327818, -0.197007843, 0.898519738];
const _fMax = [2.59, 2.37, 2.73, 2.67, 2.57, 2.34, 2.08, 2.41, 2.53, 2.71, 2.97, 2.74];

export const MeasureMinMaxGradientsOnUC = (): { min: number, max: number } => {
    var maxValue = Number.MIN_VALUE;
    var minValue = Number.MAX_VALUE;

    for (let r = 0; r < 12; r++) {
        var prev = CalculateUCV(59 / 60, r);
        for (let t = 0; t < 60; t++) {
            const offset = t / 60.0;
            const now = CalculateUCV(offset, r);
            maxValue = Math.max(maxValue, now - prev);
            minValue = Math.min(minValue, now - prev);
            prev = now;
        }
    }

    console.log('UCV max = ' + maxValue + ' UCV min = ' + minValue);
    return { min: minValue, max: maxValue };

}

const CalculateUCV = (offset: number, rotate: number): number => {
    const r = rotate % 12;

    var ff = 0;
    for (let i = 0; i < _fFactors.length; i++) {
        const angle = offset * Math.PI * (i + 1);
        const index = (i - r) < 0 ? 12 + i - r : i - r;
        ff += Math.sin(angle) * _fFactors[index];
    }

    ff = ff / _fMax[rotate % 12];
    return ff;

}

const CalculateUserCount = (start: number, end: number, offset: number, rotate: number): number => {
    const base = start + (end - start) * offset;
    if (base < 2) {
        return Math.round(base);
    }

    const ff = CalculateUCV(offset, rotate) * Math.sqrt(Math.abs(end - start));
    return Math.round(base + ff);
}

const CalculateUserCountWithDC = (before: number, start: number, end: number, offset: number, rotate: number): number[] => {
    const now = CalculateUserCount(start, end, offset, rotate);
    const prev = offset < 1 / 60 ? CalculateUserCount(before, start, 1 + offset - 1 / 60, rotate) : CalculateUserCount(start, end, offset - 1 / 60, rotate);
    const scale = start == end ? 0.0 : 2.0 / Math.sqrt(Math.abs(end - start));
    //const bounds = (start + end) < 20 ? 1.4999 : (start + end < 200 ? 2.4999 : 3.4999);
    const bounds = Math.log(start + end);
    const catRaw = now > prev ? bounds * (now - prev) * scale : -bounds * (prev - now) * scale;
    //const category = Math.round(catRaw > bounds ? bounds : (catRaw < -bounds ? -bounds : catRaw));

    //console.log('category = ' + category + ' catRaw = ' + catRaw + ' bounds=' + bounds + ' scale = ' + scale);
    return [now, catRaw];
}



export type DailyActivity = {
    year: number;
    month: number;
    day: number;
    national: number[];
    states: { [key: string]: number[] };
    stateLevels: { [key: string]: number[] };
}

export type InstantActivity = {
    time: number;
    national: number;
    states: { [key: string]: number };
    stateLevels: { [key: string]: number };
}

var todaysActivity: DailyActivity | null = null;
var tomorrowsActivity: DailyActivity | null = null;

const CheckDailyActivityFiles = async () => {
    const date = new Date(Date.now() + (24 * 3600000));

    const exists = await ExistsJSONRouteAsync('activity-' + GetDateSequence(date), 'dailyactivity');
    if(!exists){
        const output = (line : string) => { console.log(line);}
        await GenerateWeeklyActivity(output);
    }
}

export const GetTodaysActivity = async () => {
    const date = new Date();

    if (todaysActivity !== null) {
        if (todaysActivity.year === date.getUTCFullYear() && todaysActivity.month == date.getUTCMonth() && todaysActivity.day === date.getUTCDate())
            return todaysActivity;
    }
    await CheckDailyActivityFiles();
    const newActivity = await GetJSONRouteAsync('activity-' + GetDateSequence(), 'dailyactivity') as DailyActivity;
    todaysActivity = newActivity;
    return newActivity;
}

export const GetTomorrowsActivity = async () => {
    const date = new Date(Date.now() + (24 * 3600000));

    if (tomorrowsActivity !== null) {
        if (tomorrowsActivity.year === date.getUTCFullYear() && tomorrowsActivity.month == date.getUTCMonth() && tomorrowsActivity.day === date.getUTCDate())
            return tomorrowsActivity;
    }

    await CheckDailyActivityFiles();
    
    const newActivity = await GetJSONRouteAsync('activity-' + GetDateSequence(date), 'dailyactivity') as DailyActivity;
    tomorrowsActivity = newActivity;
    return newActivity;
}


export const GetNationalActivity = (activity: DailyActivity, time: number): number => {
    const relTime = time - (new Date(activity.year, activity.month, activity.day)).valueOf();
    const index = Math.floor(relTime / 3600000);
    const offset = (relTime - 3600000 * index) / 3600000;
    var national = 0.0;


    Object.keys(activity.states).forEach((key, r) => {
        const state = activity.states[key];
        const projection = CalculateUserCount(state[index], state[index + 1], offset, r);
        national += projection;
    });
    return national;

}

export const GetInstantActivity = (activity: DailyActivity, nextactivity: DailyActivity, time: number): InstantActivity => {

   // console.log('GetInstantActivity');
    const minTime = Date.UTC(activity.year, activity.month, activity.day);

    const ret: InstantActivity = {
        time: time,
        national: 0,
        states: {},
        stateLevels: {}
    }

    const index = Math.floor((time - minTime) / 3600000);
    const offset = (time - minTime - 3600000 * index) / 3600000;


    


    const ndeltas : Array<{name : string, value : number}> = [];
    const pdeltas : Array<{name : string, value : number}> = [];
    Object.keys(activity.states).forEach((key, r) => {
        const state = activity.states[key];
        //const levels = activity.stateLevels[key];

        const start = state[index];
        const end = (index + 1) >= state.length ? nextactivity.states[key][0] : state[index + 1];
        const before = index === 0 ? state[state.length - 1] : state[index - 1];

        //console.log('CalculateUserCountWithDC for ' + key + ' start = ' + start + ' end = ' + end);
        const [projection, delta] = CalculateUserCountWithDC(before, start, end, offset, r);
        /*var level = levels.length;
         for (let i = 0; i < levels.length; i++) {
             if (projection < levels[i])
                 level = i;
         }*/
        if (delta < 0)
            ndeltas.push({name : key, value : delta});
        else if (delta > 0)
            pdeltas.push({name : key, value : delta});
        else{
            ret.stateLevels[key] = 3;
            //console.log(key+ ' category = 3 raw = ' + delta)
        }
        ret.states[key] = projection;
        //ret.stateLevels[key] = 3 + delta;
        //console.log(key + ' = ' + (3 + delta));
        
        ret.national += projection;
    });

    ndeltas.sort((a,b)=> b.value - a.value);
    pdeltas.sort((a,b)=> a.value - b.value);

    const nindex3 = Math.floor(ndeltas.length / 3);
    const nindex2 = Math.floor(ndeltas.length * 2 / 3);

    for(let i = 0; i < ndeltas.length; i++)
    {
        const value = i < nindex3 ? 0 : (i < nindex2 ? 1 : 2);
        //console.log(ndeltas[i].name + ' category = ' + value + ' raw = ' + ndeltas[i].value);
        ret.stateLevels[ndeltas[i].name] = value;
    }

    const pindex3 = Math.floor(ndeltas.length * 2 / 3);
    const pindex2 = Math.floor(ndeltas.length * 1 / 3);


    for(let i = 0; i < pdeltas.length; i++)
    {
        const value = i > pindex3 ? 6 : (i > pindex2 ? 5 : 4);
        //console.log(pdeltas[i].name + ' category = ' + value + ' raw = ' + pdeltas[i].value);
        ret.stateLevels[pdeltas[i].name] = value;
    }

    
    //console.log('posCount = ' + pdeltas.length + ' negCount = ' + ndeltas.length);
    return ret;
}